<template>
  <div id="base-editor-page" class="mt-20">
    <div class="panel panel-default">
      <div class="panel-body">
        <slot name="title">
          <h1 class="mt-0">
            {{ $route.meta.name }}
          </h1>
        </slot>

        <slot name="description"></slot>
        <hr />

        <div>
          <div class="panel-body">
            <template v-if="isLoading">
              Loading...
            </template>
            <template v-else>
              <slot name="body"></slot>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'BaseEditorPage',
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
